import React from 'react';
import { Flex, Typography, theme } from 'antd';

import type { KPIComparison } from './KPIComparison';
import Percentage from './Percentage';

type KPICardContentProps = {
  comparison: KPIComparison;
  percentageColor: 'success' | 'danger';
  mainValue: string;
};
function KPICardContent({
  comparison,
  percentageColor,
  mainValue,
  children,
}: React.PropsWithChildren<KPICardContentProps>) {
  const { token } = theme.useToken();

  return (
    <>
      <Flex justify="space-between" align="center" style={{ marginTop: 25 }}>
        <Typography.Text strong style={{ fontSize: token.fontSizeHeading2 }}>
          {mainValue}
        </Typography.Text>
        <Percentage comparison={comparison} color={percentageColor} />
      </Flex>

      <div style={{ height: 64 }}>{children}</div>
    </>
  );
}

export default KPICardContent;
